'use client';

import { EmptyState } from '@yanolja-rnd/nol-design-system';

export const NoCategorySearchResult = ({ description }: { description?: string }) => {
  return (
    <div className="mt-40 flex h-full w-full justify-center bg-colors-white">
      <EmptyState
        title="조건에 맞는 상품이 없어요"
        description={description || '카테고리를 변경해 보세요.'}
        pcType="pcLegacySize"
      />
    </div>
  );
};
